import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as dailyGoalActions from '@/pages/dailyGoal/Actions';
import * as learningPathActions from '@/pages/learningPath/Actions';
import * as sharedActions from '@/shared/Actions';
import { getUpdateUserPath } from '@/services/Constants';
import { getUserId } from '@/pages/learningPath/Selectors';
import { processRequest } from '@/services/Api';
import { sendStickersOnboardedError, sendStickersOnboardedSuccess } from '../store/actions';
import { stickersOnboardingActionTypes } from '../store/constants';

import type { SagaIterator } from 'redux-saga';

export default function* stickersOnboardingSaga(): SagaIterator {
	yield all([
		yield takeLatest(
			stickersOnboardingActionTypes.SEND_STICKERS_ONBOARDED_REQUEST,
			handleSendStickersOnboardedRequest,
		),
	]);
}

export function* handleSendStickersOnboardedRequest(): SagaIterator {
	try {
		const userId: string = yield select(getUserId);

		yield call(processRequest, getUpdateUserPath(userId), 'PUT', {
			user: { onboarding_sticker_at: true },
		});

		yield put(sendStickersOnboardedSuccess());
		yield put(sharedActions.getUserDataRequest());
		yield put(dailyGoalActions.getUserStickersRequest());
		yield put(learningPathActions.setLearningPathUpdated(true));
		yield put(learningPathActions.setFinishTileAnimation(true));
	} catch (e) {
		yield put(sendStickersOnboardedError());
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}
